module.exports = __webpack_public_path__ + "img/aj.71f5b7a0.png";